import { LabelValueProps } from "./InfoItem/components";
import { InfoItemProps } from "./InfoItem/InfoItem";

export const shouldBeHidden = (item: LabelValueProps | InfoItemProps): boolean => {
    if ("features" in item && item.features.length > 0) {
        return false;
    }

    if ("payments" in item && item.payments.length > 0) {
        return false;
    }

    if ("values" in item && item.values.length > 0) {
        return false;
    }

    if ("value" in item) {
        const valueIsZero = item.value === "0" || item.value === 0;
        if (!item.value && !valueIsZero) return true;
        return "hideIfZero" in item && item.hideIfZero && valueIsZero;
    }

    return true;
};
